import * as React from 'react';
import { SVGProps } from 'react';

const SvgPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 8.64 15.27 12 10 15.36V8.64zM8 5v14l11-7L8 5z" />
  </svg>
);

export default SvgPlay;
